export async function initCartoDb() {
    // eslint-disable-next-line import/no-unresolved
    const module = await import('../../../../../js/responsive/maps/cartodb?raw');
    // eslint-disable-next-line no-useless-call, no-eval
    eval.call(null, module.default);
}
